import axios from '../axiosInstances/axiosInstance';

export const getReferralCode = () => {
  return axios.post(`/users/referrals/code`);
};
